export default class AreaOfStudyTypeDomainService {
    static fromJSON(json) {
        return Object.assign({}, json);
    }
    static get MAJOR_ID() {
        return 1;
    }
    static get MINOR_ID() {
        return 2;
    }
    static get CONCENTRATION_ID() {
        return 3;
    }
    static get SPECIALIZATION_ID() {
        return 4;
    }
}
